import { Paginated, Sortable } from "@ac-expo/api-types";

export type ClientsFilter = {
  searchText?: string;
} & Sortable<Paginated>;

export const accountingQueryKeys = {
  all: ["accountings"] as const,
  prestations: (filters?: Sortable<Paginated>) => [
    ...accountingQueryKeys.all,
    "prestations",
    filters,
  ],
  clients: (filters?: ClientsFilter) => [
    ...accountingQueryKeys.all,
    "clients",
    filters,
  ],
  ticketing: (filters?: Sortable<Paginated>) => [
    ...accountingQueryKeys.all,
    "ticketing",
    filters,
  ],
  invoices: (filters?: Sortable<Paginated>) => [
    ...accountingQueryKeys.all,
    "invoices",
    filters,
  ],
  purchases: (filters?: Sortable<Paginated>) => [
    ...accountingQueryKeys.all,
    "purchases",
    filters,
  ],
};
